module["exports"] = [
  " s/n.",
  ", #",
  ", ##",
  " #",
  " ##"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/building_number.js
 ** module id = 472
 ** module chunks = 0
 **/